import { ToastContainer } from "react-toastify";
import Footer from "../../../components/footer";
import "./style.css";
import { ModalFilterClient } from "../../../components/register/register-cliente/filter";
import { ContextRegisterClient } from "../../../components/register/register-cliente/context";
import { useContext, useEffect, useMemo, useState } from "react";
import Notification from "../../../components/toast";
import { ModalRegisterClient } from "../../../components/register/register-cliente/modal-register";
import TableClients from "../../../components/register/register-cliente/table";
import { ListFilter } from "../../../components/list-filter";
import HeaderReport from "../../../components/header/report";
import ModalMain from "../../../components/modal";
import ReportModalContent from "../../../components/report/ReportModalContent";

// Os relatórios genéricos (ReportModalContent/generateReport) esperam filtros no formato { chave: { label, value } }
const PARAM_LABELS = {
	nome: "Nome",
	cidade: "Cidade",
	endereco: "Endereço",
	telefone: "Telefone",
};

export const MainRegisterClient = ({ isSelector = false, onSelectClient }) => {
	const options = {
		title: "Cadastro de Clientes",
		subTitle: "Cliente",
		identReport: `reportClient`, //usado para definir os event listners
		reportColumns: [
			{ key: "nome", label: "Nome", align: "left", visible: true },
			{ key: "fantasia", label: "Fantasia", align: "left", visible: true },
			{ key: "cpf", label: "CPF", align: "center", visible: true },
			{ key: "rg", label: "RG", align: "center", visible: false },
			{ key: "telefone_1", label: "Telefone 1", align: "center", visible: true },
			{ key: "telefone_2", label: "Telefone 2", align: "center", visible: false },
			{ key: "telefone_3", label: "Telefone 3", align: "center", visible: false },
			{ key: "email", label: "Email", align: "left", visible: true },
			{ key: "nomecidade", label: "Cidade", align: "left", visible: true },
			{ key: "uf", label: "UF", align: "center", visible: true },
			{ key: "rua", label: "Rua", align: "left", visible: false },
			{ key: "numero", label: "Número", align: "center", visible: false },
			{ key: "bairro", label: "Bairro", align: "left", visible: false },
			{ key: "cep", label: "CEP", align: "center", visible: false },
			{ key: "ativo", label: "Ativo", align: "center", format: "badgePgto", visible: true },
			{ key: "data_cadastro", label: "Data Cadastro", align: "left", format: "datetime", visible: true },
			{
				key: "data_movimentacao",
				label: "Última Movimentação",
				align: "left",
				format: "datetime",
				visible: false,
			},
			{ key: "limite", label: "Limite Crédito", align: "right", format: "currency", visible: false },
			{ key: "limitevale", label: "Limite Vale", align: "right", format: "currency", visible: false },
		],
	};

	const { openModalFilterClient, openModalRegisterClient, filterData, fetchAllClients } =
		useContext(ContextRegisterClient);

	const [reportData, setReportData] = useState([]);
	const [isLoadingReport, setIsLoadingReport] = useState(false);

	useEffect(() => {
		if (isSelector) {
			openModalFilterClient();
		}
	}, []);

	const handleOpenModalReport = async () => {
		try {
			setIsLoadingReport(true);
			const data = await fetchAllClients();
			setReportData(data);

			const event = new CustomEvent(`${options.identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setIsLoadingReport(false);
		}
	};

	const reportFilters = useMemo(() => {
		if (!filterData || typeof filterData !== "object") return {};

		const filters = {};

		if (filterData.param) {
			filters.param = {
				label: PARAM_LABELS[filterData.param] || "Parâmetro",
				value: filterData.paramValue || "",
			};
		}

		if (filterData.ativo) {
			filters.ativo = {
				label: "Ativo",
				value: filterData.ativo,
			};
		}

		return filters;
	}, [filterData]);

	return (
		<div className="container-register">
			<header className="mt-page">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={options.title} subTitle={options.subTitle} />
					</div>
					<div className="col-span-1 flex justify-end">
						<ListFilter filterData={filterData} />
					</div>
				</div>

				<ModalFilterClient />
				<ModalRegisterClient />
				<ToastContainer />
				{/* <div className="d-flex align-items-center justify-content-between">
					<button className="btn btn-sm btn-success w-15" onClick={(e) => openModalRegisterClient()}>
						Cadastrar Cliente
					</button>
					<button className="btn btn-sm btn-primary w-25" onClick={(e) => openModalFilterClient()}>
						Listar
					</button>
				</div> */}
				<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<button className="min-w-40 btn btn-sm btn-success w-15" onClick={(e) => openModalRegisterClient()}>
						{options.title}
					</button>
					<div className="flex gap-2 flex-wrap ">
						<button
							className="min-w-40 btn btn-sm btn-primary w-25"
							onClick={(e) => openModalFilterClient(e)}
						>
							Listar
						</button>
						{options.reportColumns && (
							<button
								className="min-w-40 btn btn-sm btn-danger"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
					</div>
				</div>
			</header>
			<main>
				<TableClients isSelector={isSelector} onSelectClient={onSelectClient} />
			</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identReport}>
				<ReportModalContent
					reportColumns={options.reportColumns}
					data={reportData}
					filters={reportFilters}
					title={options.title}
					headerSubtitle={options.subTitle}
					defaultFormat="pdf" // ou "csv"
				/>
			</ModalMain>
		</div>
	);
};
